import React from 'react';
import { connect } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

const PrivateRoute = (props) => {
  const {
    children,
    session: {
      isAuthenticated = false,
      role,
    },
    role: routeRole,
  } = props;

  const location = useLocation();

  if (!isAuthenticated || (routeRole !== undefined && role !== routeRole)) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

const mapStateToProps = (state) => ({
  session: state.session.session || {},
});

export default connect(mapStateToProps)(PrivateRoute);
